import { useQuery } from '@tanstack/react-query';
import { api, get } from '../../lib/api';

// only a front end validation, update max_file_size in app/controllers/client_admin/aws_settings_controller.rb
// to change aws bucket policy for file size
export const MAX_ATTACHMENT_SIZE = 35000000;
export const SUCCESS_NO_CONTENT = 204;
export const SPECIAL_CHARACTER_REGEX = /[^\w._]/gi;
export const TILE_BUTTON_CHARACTERS_LIMIT = 50;
export const SURVEY_FREE_RESPONSE_CHARACTER_LIMIT = 400;
export const ACTION_BUTTON_CHARACTERS_LIMIT = 50;
export const VALID_IMG_ATTACHMENTS = '.png, .jpg, .jpeg, .gif, .webm';
export const VALID_ATTACHMENTS = VALID_IMG_ATTACHMENTS.concat(
  '.yml, .csv, .pdf',
);

const parseTile = tile => {
  return {
    assignee_id: tile.assigneeId,
    headline: tile.headline,
    disclaimer_text: tile.disclaimerText,
    supporting_content: tile.supportingContent,
    attachments: ['DELETE'].concat(Object.values(tile.attachments)),
    media_source: tile.mediaSource,
    remote_media_url: tile.remoteMediaUrl,
    image_credit: tile.imageCredit,
    embed_video: tile.embedVideo,
    question_type: tile.questionType,
    question_subtype: tile.questionSubtype,
    correct_answer_index: tile.correctAnswerIndex,
    question: tile.question,
    answers: tile.answers,
    points: tile.points,
    allow_free_response: tile.allowFreeResponse,
    is_anonymous: tile.isAnonymous,
    is_sharable: tile.isSharable,
    is_public: tile.isPublic,
    audience_id: tile.audienceId,
    ribbon_tag_id: tile.ribbonTagId,
    post_id: tile.postId,
    new_position: tile.newPosition,
  };
};

export const createTile = tileData => {
  const parsedTileData = parseTile(tileData);

  return api({
    method: 'post',
    url: '/api/client_admin/tile',
    data: {
      tile: { ...parsedTileData, status: 'plan' },
    },
  });
};

export const updateTile = tileData => {
  const parsedTileData = parseTile(tileData);

  return api({
    method: 'patch',
    url: `/api/client_admin/tile/${tileData.id}`,
    data: {
      tile: { ...parsedTileData },
    },
  });
};

export const saveTile = tileData => {
  if (tileData.id) return updateTile(tileData);

  return createTile(tileData);
};

export const useGetAudienceAndRibbonTag = () => {
  const { data = [] } = useQuery(['getAudienceAndRibbonTag'], () =>
    get('/api/client_admin/tile_form'),
  );

  return data;
};
